import React from "react";
import './start-assessment.scss';
import { getImageSource, getThemeImageSource } from "../../../utility/image-source";
import { Constants, FirebaseEvents, ImageConstants } from "../../../constants/constants";
import SharedThemeCategory from "../../../../shared-storage/category-theme";
import AssessmentApi from "../../../apis/assessment";
import Loading from "../../common/loading/loading";
import Path from "../../routes/routes-path";
import Dropdown from '../../common/dropdown-v2/dropdown';
import SchoolApi from "../../../apis/school";
// import ChapterListPopup from "../../my-classwork/chapter-list-popup/chapter-list-popup";
// import FireBaseEvent from '../../../firebase-events/firebase-events';

import LayoutShared from "../../common/layout-shared/layout-shared";
import { Modal, ModalBody } from "reactstrap";
import HomeworkForClickerPracticeApi from "../../../apis/homework-for-clicker-practice";
import CommonUtils from "../../../utility/common-utilities";
import IndexedDBHelperV2 from "../../../offline/apis/indexDBManager-v2";
const dbHelper = new IndexedDBHelperV2(Constants.DB_NAME, Constants.DB_VERSION, Constants.STORE_CONFIG);

class StartAssessment extends React.Component {

    chapterKeys = [];
    chapterTitles = [];
    categoryIds = [];
    multipleChapters = []


    state = {
        categoryThemeId: 1,
        questionCount: -1,
        showQuestionSetList: false,
        questionSetList: [],
        studentList: [],
        isListening: false,
        hideLayoutSideBar: true,
        showClickerSetPopup: this.props.selectedSetOption && this.props.selectedSetOption.value ? false : true,
        clickerSetDropdown: this.props.meta.clickerSet && this.props.meta.clickerSet.length ? this.props.meta.clickerSet : [],

        // questionCount: 5,
        //         questionSetId: '123',
        //         duration: 10,
        //         totalMarks: 10,
        list: [
            {
                tip: "Please have pen & paper with you before you start the Assessment."
            },
            {
                tip: "You can go back to any attempted Question just by tapping on the Question number in the top bar."
            },
            {
                tip: "You can flag any question and come back to answer it later, before finishing the Assessment."
            }
        ]

    }

    constructor(props) {
        super(props)

        this.meta = this.props.meta
        // this.userInfo = SharedProfile.getProfile();
        this.layoutShared = LayoutShared.getLayout()


    }

    componentDidMount() {
        // this.getMyAssessmentInfo()
        // this.setState({ studentList: this.props.studentList })


        if (this.props.meta.clickerSet && this.props.meta.clickerSet.length === 1) {
            this.onSelectDropDown(this.props.meta.clickerSet[0], "selectedSetId")
        }

        if (this.props.selectedSetOption && this.props.selectedSetOption.value) {
            this.onSelectDropDown(this.props.selectedSetOption, "selectedSetId")
        }


        this.handleStartListening()
        // console.log(this.layoutShared)
        if (this.props.meta.homework.type === Constants.CLICKER_CONCEPT_CARD && this.props.meta.typeOfSchoolwork === 'CLASSWORK') {
        } else {
            this.toggleLayoutBar()
        }


        if (window.AndroidClicker) {
            this.startScanning()
            // Set up the global function to receive click events from WebView
            // window.onClickEvent = (event) => {
            //     console.log("Click Event Received:", event);

            //     // Ensure the event is parsed from JSON if necessary
            //     const clickData = typeof event === "string" ? JSON.parse(event) : event;

            //     // Update the component state with new click event data
            //     this.setState({ clickData });
            // };

            this.handleStartListening()

            // setTimeout(() => {
            //     const mockEvent = { btnNum: 1, battery: "HIGH", id: "MOCK_ID" };
            //     window.onClickEvent(JSON.stringify(mockEvent));
            //   }, 5000);
        }

        if (this.props.meta.typeOfSchoolwork === 'REVISION_FLOW') {
            this.setState({ showRevisionStartScreen: true })
        }

    }

    startScanning = () => {
        if (window.AndroidClicker) {
            console.log('scanning Started.......')
            window.AndroidClicker.startScanning(); // Calls native Android function
        } else {
            console.log("AndroidClicker interface not found!");
        }
    };

    stopScanning = () => {
        if (window.AndroidClicker) {
            console.log('scanning Stoped.......')
            window.AndroidClicker.stopScanning(); // Calls native Android function
        } else {
            console.log("AndroidClicker interface not found!");
        }
    };

    getMyAssessmentInfo(questionSetId) {

        console.log('inside')

        // let payload = {}
        this.toggleLoading(true)


        // AssessmentApi.getMyAssessmentInfo(payload).then((res) => {
        this.setState({
            questionCount: 10,
            questionSetId: '123',
            duration: 20,
            totalMarks: 10,
            showQuestionSetList: false,
        })
        this.toggleLoading(false)
        // }).catch(err => {
        //     //console.log(err)
        //     if (err) {
        //         this.toggleLoading(false)

        //         if (err.response && err.response.data && err.response.data.code == 1801) {
        //             // this.props.navigation.navigate('EventEndScreen', {
        //             //     meta: {
        //             //         title: this.meta.chapterTitle,
        //             //         categoryThemeId: '1',
        //             //         assessmentId: this.meta.assessmentId,
        //             //         eventId: this.meta.eventId
        //             //     }
        //             // })
        //         }
        //         return;
        //     }
        // })
    }

    getChapterAssessmentQuestionSetList() {

        let payload = {}
        if (!this.chapterKey)
            return;

        this.toggleLoading(true)

        payload = {
            chapterKey: this.chapterKey,
            duration: this.state.selectedDuration
        }
        AssessmentApi.getChapterAssessmentQuestionSetList(payload).then(res => {
            console.log(res)

            if (res.questionSetList && res.questionSetList.length) {
                this.setState({ showQuestionSetList: true, questionSetList: res.questionSetList })
            } else {
                this.setState({ questionCount: 0 })
            }

            this.toggleLoading(false)
        }).catch(err => {
            this.toggleLoading(false)
            console.log(err)
        })
    }

    toggleLayoutBar() {
        console.log('toggle called')

        // this.setState({hideLayoutSideBar : !this.state.hideLayoutSideBar}, () => {
        this.layoutShared.showHideLayoutBar(!this.layoutShared.state.showLayoutBar)

        if (window.electron) {
            window.electron.ipcRenderer.send('toggle-fullscreen', ['ping']);
        }


        // this.layoutShared.toggleSidebar(this.state.hideLayoutSideBar)
        // })

    }


    handleStartListening = () => {
        const { isListening } = this.state;

        if (window.electron && window.electron.remoteControl) {
            if (isListening) {
                this.setState({ isListening: false });
                window.electron.remoteControl.unsubscribeEvents();
                window.electron.remoteControl.close();
            } else {
                this.setState({ isListening: true });
                console.log('Opening remote control', window.electron.remoteControl.open);
                window.electron.remoteControl.open();

                window.electron.remoteControl.subscribeEvents((data) => {
                    console.log('Received data:', data);

                    let studentList = this.state.studentList
                    console.log(studentList)

                    let index = studentList.findIndex(item => item.userDeviceMacId === data.payload.id)

                    console.log(index)

                    if (index != -1) {
                        if (studentList[index].isTeacher && data.payload.value === 8) {
                            this.toggleLayoutBar()

                        }

                        if (studentList[index].isTeacher && data.payload.value === 1) {
                            this.onClickStart()
                        }

                    } else if (this.props.isReadOnly) {
                    }

                });
            }
            window.electron.ipcRenderer.once('ipc-example', (arg) => {
                // eslint-disable-next-line no-console
                console.log(arg);
            });
            window.electron.ipcRenderer.send('ipc-example', ['ping']);
        }

        if (window.AndroidClicker) {
            // Set up the global function to receive click events from WebView
            window.onClickEvent = (event) => {
                console.log("Click Event Received:", event);

                // Ensure the event is parsed from JSON if necessary
                let clickData = typeof event === "string" ? JSON.parse(event) : event;

                clickData.value += 1

                console.log(clickData)

                let studentList = this.state.studentList

                let index = studentList.findIndex(item => item.userDeviceMacId === clickData.id)

                console.log(index)

                if (index != -1) {
                    if (studentList[index].isTeacher && clickData.value === 8) {
                        this.toggleLayoutBar()
                    }

                    if (studentList[index].isTeacher && clickData.value === 1) {
                        this.onClickStart()
                    }

                } else if (this.props.isReadOnly) {
                }


                // Update the component state with new click event data
                // this.setState({ clickData });
            };
        }


    };

    componentWillUnmount() {
        // Cleanup on component unmount
        console.log('component unmounted')
        if (window.electron && window.electron.remoteControl) {
            window.electron.remoteControl.unsubscribeEvents();
            window.electron.remoteControl.close();
        }

        if (window.AndroidClicker) {
            this.stopScanning()
        }

    }

    onPressAction(item) {

        if (item.status === 'COMPLETED') return;

        if (item.status === 'START') {
            this.toggleLoading(true)
            this.getMyAssessmentInfo(item._id)
        }

        if (item.status === 'IN_PROGRESS') {
            item.chapterKey = this.chapterKey
            item.chapterTitle = this.state.chapterTitle
            item.categoryId = this.state.categoryId
            item._id = item.assessmentActivityId
            this.props.delegate && this.props.delegate.onClickCard(item)
        }

    }

    toggleLoading(value) {
        this.setState({ loading: value })
    }


    showMore() {
        let viewMoreText = document.getElementById('show-more')
        let viewTableRows = [...document.getElementsByClassName('hide-list')]

        //console.log(viewMoreText.innerHTML)
        if (viewMoreText.innerHTML == "See More") {
            //console.log('1')
            viewMoreText.innerHTML = "See Less"
            viewTableRows.forEach(element => element.style.display = 'list-item')

        } else {
            //console.log('2')

            viewMoreText.innerHTML = "See More"
            viewTableRows.forEach(element => element.style.display = 'none')
        }
    }

    goBack() {
        this.props.delegate && this.props.delegate.hideStartPracticeScreen && this.props.delegate.hideStartPracticeScreen()
    }

    getAssessmentStartingPoint = () => {
        if (this.meta && this.meta.isFromMyHomework) {
            return Constants.SCHOOL_ASSIGNMENT
        }
        if (this.meta && (this.meta.from == Constants.REWARD_EVENT_BASELINE || this.meta.from == Constants.REFRESHER_COURSE || (this.meta.from == Constants.EVENT_BASELINE))) {
            return 'Event Baseline Assessment'
        }

        if (this.meta && (this.meta.from == Constants.SCHOLARSHIP_MAY_9_2021 || this.meta.from == Constants.REWARD_EVENT_FINAL || this.meta.from == Constants.REFRESHER_COURSE || (this.meta.from == Constants.SCHOLARSHIP_EVENT))) {
            return 'Event Finishline Assessment'
        }

        if (this.meta && this.meta.from == Constants.MPL_EVENT) {
            return 'MPL Event'
        }
        return "Chapter Assessment"
    }


    onClickStart = () => {
        if (this.props.meta.typeOfSchoolwork === 'REVISION_FLOW') {
            this.props.delegate && this.props.delegate.showRevisionExpereince && this.props.delegate.showRevisionExpereince(this.state.studentList, this.state.selectedSetOption)
        } else {
            this.props.delegate && this.props.delegate.showStandardPracticeExperience && this.props.delegate.showStandardPracticeExperience(this.state.studentList)
        }

    }

    showChapters = () => {
        this.setState({ showChaptersPopup: true })
    }

    hideChapters = () => {
        this.setState({ showChaptersPopup: false })
    }


    goToHomeScreen() {

        if (this.layoutShared.state.showLayoutBar) {
            // this.layoutShared.showHideLayoutBar(this.layoutShared.state.showLayoutBar)
        } else {
            this.layoutShared.showHideLayoutBar(!this.layoutShared.state.showLayoutBar)
            window.electron.ipcRenderer.send('toggle-fullscreen', ['ping']);
        }


        return this.props.delegate?.props.history.replace({ pathname: Path.HOME })
    }

    goToDiagnosticAssessmentList() {
        return this.props.delegate?.props.history.replace({ pathname: Path.DIAGNOSTIC_ASSESSMENT_LIST })
    }




    renderBreadcrumb() {

        if (this.meta.isFromMyHomework) {
            return (
                <div className='breadcrumb-for-classwork mt-2'>
                    <span className="home cursor-pointer" onClick={() => this.goToHomeScreen()}>{`Home >`}</span>
                    <span className='pl-2 cursor-pointer title-1' onClick={() => this.goBack()}>{`${this.meta.isFromMyClasswork ? "School Assignments" : 'My Homeworks'}`} {`>`}</span>
                    {/* <span className='pl-2 title-2'>{`Start Assessment`} {`>`}</span>
                    <span className='pl-2 title-3'>{`Assessment Completed`} {`>`}</span> */}
                    <span className='pl-2 title-1'>{`Start Assessment`}</span>
                </div>
            )
        }

        if (this.meta.from === Constants.REFRESHER_COURSE) {
            return (
                <div className='breadcrumb-for-classwork mt-2'>
                    <span className="home cursor-pointer" onClick={() => this.goToHomeScreen()}>{`Home >`}</span>
                    <span className='pl-2 cursor-pointer title-1' onClick={() => this.goBack()}>{this.meta.chapterTitle} {`>`}</span>
                    {/* <span className='pl-2 title-2'>{`Start Assessment`} {`>`}</span>
                    <span className='pl-2 title-3'>{`Assessment Completed`} {`>`}</span> */}
                    <span className='pl-2 title-1'>{`Start Assessment`}</span>
                </div>
            )
        }

        if (this.meta.from === 'CLASS_MOCK_TEST') {
            return (
                <div className='breadcrumb mt-2'>
                    <span className="home cursor-pointer" onClick={() => this.goToHomeScreen()}>{`Home >`}</span>
                    <span className='pl-2 cursor-pointer title-1' onClick={() => this.goToDiagnosticAssessmentList()} >{this.meta.chapterTitle} {`>`}</span>
                    {/* <span className='pl-2 title-2'>{`Start Assessment`} {`>`}</span>
                    <span className='pl-2 title-3'>{`Assessment Completed`} {`>`}</span> */}
                    <span className='pl-2 title-1'>{`Start Assessment`}</span>
                </div>
            )
        }

        if (this.meta.from === 'SCIENCE_CLASS_MOCK_TEST') {
            return (
                <div className='breadcrumb mt-2'>
                    <span className="home cursor-pointer" onClick={() => this.goToHomeScreen()}>{`Home >`}</span>
                    <span className='pl-2 cursor-pointer title-1' onClick={() => this.goToDiagnosticAssessmentList()}>{this.meta.chapterTitle} {`>`}</span>
                    {/* <span className='pl-2 title-2'>{`Start Assessment`} {`>`}</span>
                    <span className='pl-2 title-3'>{`Assessment Completed`} {`>`}</span> */}
                    <span className='pl-2 title-1'>{`Start Assessment`}</span>
                </div>
            )
        }


        return (

            <div className='breadcrumb mt-2'>
                <span className="home cursor-pointer" onClick={() => this.goToHomeScreen()}>{`Home >`}</span>
                <span className='pl-2 cursor-pointer title-1' onClick={() => this.goBack()}>{`Clicker Flow`} {`>`}</span>

                <span className='pl-2 title-1'>{`Start Clicker Flow`}</span>
            </div>

        )
    }



    getAssessmentDetailCardForRevisionStartScreen() {
        return (
            <div className="d-flex justify-content-center align-items-center mt-2">
                <div className="row justify-content-between align-items-center assessment-detail-card pl-2 pr-2">
                    <div className="col d-flex justify-content-center">
                        <div>
                            <div className="text-center">Duration</div>
                            <div className="d-flex justify-content-center align-items-center">
                                <div><img className="clock-image-size mr-2" src={getImageSource(ImageConstants.CLOCK_IMAGE)} /></div>
                                <div className="min-text">{this.meta.homework.approximateTime} min</div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="line-wrapper"><img className="vertical-line" src={getImageSource(ImageConstants.VERTICAL_LINE)} /></div>
                    <div className="col-3 d-flex justify-content-center">
                        <div>
                            <div className="text-center">Marks</div>
                            <div className="d-flex justify-content-center align-items-center">
                                <div><img className="clock-image-size mr-2" src={getImageSource(ImageConstants.EXAM_PAD_ICON_BLOCK)} /></div>
                                <div className="min-text">{this.state.totalMarks}</div>
                            </div>
                        </div>

                    </div> */}
                    <div className="line-wrapper"><img className="vertical-line" src={getImageSource(ImageConstants.VERTICAL_LINE)} /></div>
                    <div className="col d-flex justify-content-center">
                        <div className="">
                            <div className="text-center">Questions</div>
                            <div className="d-flex justify-content-center align-items-center">
                                <div><img className="clock-image-size mr-2" src={getImageSource(ImageConstants.QUESTION_MARK)} /></div>
                                <div className="min-text">{this.meta.homework.approximateQuestions}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    getAssessmentDetailCard() {
        return (
            <div className="d-flex justify-content-center align-items-center mt-2">
                <div className="row justify-content-between align-items-center assessment-detail-card pl-2 pr-2">
                    <div className="col d-flex justify-content-center">
                        <div>
                            <div className="text-center marks-text">Duration</div>
                            <div className="d-flex justify-content-center align-items-center">
                                <div><img className="clock-image-size mr-2" src={getImageSource(ImageConstants.CLOCK_IMAGE)} /></div>
                                <div className="min-text">{this.meta.homework.approximateTime} min</div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="line-wrapper"><img className="vertical-line" src={getImageSource(ImageConstants.VERTICAL_LINE)} /></div>
                    <div className="col-3 d-flex justify-content-center">
                        <div>
                            <div className="text-center">Marks</div>
                            <div className="d-flex justify-content-center align-items-center">
                                <div><img className="clock-image-size mr-2" src={getImageSource(ImageConstants.EXAM_PAD_ICON_BLOCK)} /></div>
                                <div className="min-text">{this.state.totalMarks}</div>
                            </div>
                        </div>

                    </div> */}
                    <div className="line-wrapper"><img className="vertical-line" src={getImageSource(ImageConstants.VERTICAL_LINE)} /></div>
                    <div className="col d-flex justify-content-center">
                        <div className="">
                            <div className="text-center marks-text">Questions</div>
                            <div className="d-flex justify-content-center align-items-center">
                                <div><img className="clock-image-size mr-2" src={getImageSource(ImageConstants.QUESTION_MARK)} /></div>
                                <div className="min-text">{this.meta.homework.approximateQuestions}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    getButton(item) {
        if (item.status === 'START') {
            return 'Start'
        }
        if (item.status === 'IN_PROGRESS') {
            return 'Resume'
        }
        if (item.status === 'COMPLETED') {
            return 'Completed'
        }
    }

    renderQuestionSetList() {
        return (
            <div>
                <div className="mock-test-header">Select a Mock Test</div>
                {
                    this.state.questionSetList.map((item, index) => (
                        <div onClick={() => this.onPressAction(item)}
                            className='d-flex align-items-center justify-content-between chapter-card pl-0 pt-3 pb-3 cursor-pointer'>
                            <div className='d-flex align-items-center'>
                                <div className='d-flex align-items-center'>
                                    <div>
                                        <div className='chapter-title'>Mock Test {index + 1}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex justify-content-center align-items-center">
                                <div className="take-challenge text-center">{this.getButton(item)}</div>
                            </div>
                            {/* <div>
                                <img className='arrow-image-size' src={getImageSource(ImageConstants.BLUE_ARROW_ICON)}></img>
                            </div> */}
                        </div>
                    ))
                }
            </div>
        )
    }

    onSelectDropDown(option, key) {
        this.setState({ [key]: option?.value, selectedSetOption: option }, () => {
            // this.getUserClickerList(option)
            this.onClickDone()
        })
    }

    onClickDone() {
        if (!this.state.selectedSetId) return
        this.getUserClickerList(this.state.selectedSetOption)
    }

    getUserClickerList(option) {
        let payload = {
            selectedSetId: this.state.selectedSetId,
            homeworkId: this.meta.homeworkId
        }

        if (CommonUtils.isOnline()) {
            SchoolApi.getUserClickerList(payload).then(res => {
                console.log(res)
                this.setState({ showClickerSetPopup: false, studentList: res.clickerUserList }, () => {
                    this.updateClickerSetInHomework(option)
                })
            }).catch(err => {
                console.log(err)
            })
        } else if (!CommonUtils.isOnline()) {

            let studentClickerList = option.studentClickerList

            let studentClickerListhash = {}

            for (let i = 0; i < studentClickerList.length; i++) {
                studentClickerListhash[i + 1] = studentClickerList[i]
            }

            let studentList = this.props.studentList

            studentList.forEach(item => {
                if (item.isTeacher) {
                    item.userDeviceMacId = option.teacherClickerId.deviceMacId
                } else if (studentClickerListhash[item.studentNumber]) {
                    item.userDeviceMacId = studentClickerListhash[item.studentNumber].deviceMacId
                }
            })

            console.log(studentList)

            this.setState({ showClickerSetPopup: false, studentList }, () => {
                dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'homeworkId', this.meta.homeworkId).then(res => {

                    res[0].selectedSetId = option.value
                    res[0].selectedSetTitle = option.title
                    console.log(res)
                    dbHelper.updateBulkData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, res).then(teacherActivityRes => {
                        dbHelper.getData(Constants.HOMEWORK_STORE, this.meta.homeworkId).then(homeworkData => {
                            console.log(homeworkData)
                            homeworkData.selectedSetId = option.value
                            homeworkData.selectedSetTitle = option.title
                            homeworkData = [homeworkData]
                            dbHelper.updateBulkData(Constants.HOMEWORK_STORE, homeworkData).then(updatedHomeworkData => {

                            })
                        })
                    })
                }).catch(err => {
                    console.log(err)
                })
            })
        }
    }

    updateClickerSetInHomework(option) {
        let payload = {
            selectedSetId: this.state.selectedSetId,
            selectedSetTitle: option?.title,
            homeworkId: this.meta.homeworkId
        }

        HomeworkForClickerPracticeApi.updateHomeworkClickerPractice(payload).then(res => {
            console.log(res)
        }).catch(err => {
            console.log(err)
        })
    }


    renderClickerSetPopup() {
        return <Modal className="cw-custom-modal-for-clicker-set-new" isOpen={true} toggle={this.hideReminderModal} size={'md'}>
            <ModalBody >
                <div className="homework-assign-popup">
                    <div className="d-flex justify-content-between heading">
                        <div className="">Please Select a Clicker Set to Start the Practice<div className="heading-subtext">{this.state.selectedConceptName}</div></div>
                        <div className="my-auto"><img className='close-icon close-icon-position cursor-pointer' src={getImageSource(ImageConstants.CLOSE_ICON_BLOCK_CROSS)} onClick={() => this.goBack()} /></div>
                    </div>
                    <div className="mt-2 mb-b ml-3 clicker-set-wrapper" >
                        {/* <div className="col-lg-6 col-md-8 col-sm-12">
                            <div className="filter-input-label">
                                Select a Clicker Set<span className='text-danger'>*</span>
                            </div>
                            <div className={this.props.isCreate && !this.state.selectedChapterKey ? 'error-border' : ''}>
                                {!this.state.reloadDropdown ?
                                    <Dropdown
                                        placeholder='Select a Set'
                                        options={this.state.clickerSetDropdown}
                                        onSelect={(option) => this.onSelectDropDown(option, "selectedSetId")}
                                        text={"title"}
                                        value={this.state.selectedSetId}
                                    // disabled={this.props.delegate?.props?.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload?.forWhat === 'PREVIOUS_KNOWLEDGE'}
                                    >
                                    </Dropdown> : ''
                                }
                            </div>
                            {this.props.isCreate && !this.state.selectedChapterKey ? <div className='error-text text-danger'>Please Select a Chapter</div> : ''}
                        </div> */}

                        {
                            this.state.clickerSetDropdown.map((item, index) => (
                                <div className="d-flex justify-content-center mt-3" >
                                    <div className={`button-wrapper cursor-pointer ${this.state.selectedSetId === item.value ? "selected-active-set" : ""} `}
                                        onClick={() => this.onSelectDropDown(item, "selectedSetId")}>
                                        <div className={`start-button ${this.state.selectedSetId === item.value ? "active-button" : ""}`}>{item.title}</div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>

                    <div className="d-flex justify-content-center mt-3 mb-4">
                        <div className="view-answer-wrapper text-center cursor-pointer" onClick={() => this.onClickDone()}>
                            <div className="view-answer-button">Done</div>
                        </div>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    }



    render() {

        this.theme = SharedThemeCategory.getThemeCategory(this.state.categoryId)

        return (
            <div className="start-assessment-for-clicker-assessment-new-v3 container-fluid p-0">
                <div className="text-right">
                    <img className="image-size" src={getThemeImageSource(ImageConstants.PRACTICE_QUESTION_HEADER, this.state.categoryId)}></img>
                </div>
                <div className="header-for-practice-question">
                    {this.renderBreadcrumb()}
                    {/* <div>
                        <img className="chapter-icon mr-1" src={this.state.selectedChapter.chapterImage ? this.state.selectedChapter.chapterImage : getImageSource(ImageConstants.CHAPTER_ICN)} />
                        <span className="chapter-title">{this.state.selectedChapter.title}</span>
                    </div> */}
                    <div className="sub-header-text">{this.meta.title}</div>
                </div>
                <div>
                    <img className="divider-image-width" src={getThemeImageSource(ImageConstants.PRACTICE_QUESTION_HEADER_DIVIDER, this.state.categoryId)}></img>
                </div>

                {this.state.loading && <Loading />}
                <>
                    <div className="row mr-0">
                        <div className="col d-flex justify-content-center guide-title">Help Guide for Teacher</div>
                    </div>
                    <div className="row mr-0">
                        <div className="col d-flex justify-content-center guide-sub-title">Learn how to use your teacher clicker effectively with this comprehensive button guide</div>
                    </div>
                    <div className="row mr-0">
                        <div className="col d-flex justify-content-center" style={{ marginLeft: '12rem' }}><img className="teacher-clicker-image" src={getImageSource(ImageConstants.TEACHER_CLICKER_INFO)} /></div>
                    </div>
                    {
                        this.state.showRevisionStartScreen ?
                            // this.getAssessmentDetailCardForRevisionStartScreen()
                            <></>
                            :
                            this.getAssessmentDetailCard()
                    }

                    {/* <div className="row mr-0 mt-4 mb-3">
                        <div className="col text-center"><img className="teacher-clicker-image" src={getImageSource(ImageConstants.TEACHER_CLICKER_INFO)} /></div>
                    </div> */}

                    <div className="d-flex justify-content-center">
                        {/* <div className="text-center back-button cursor-pointer mr-5"
                                    style={{ color: this.theme ? `${this.theme[`themeColor`]}` : '', border: `2px solid ${this.theme[`themeColor`]}` }}
                                    onClick={() => this.goBack()}>Back</div> */}

                        <div className="text-center continue-button cursor-pointer"
                            style={{ backgroundColor: this.theme ? `${this.theme[`themeColor`]}` : '' }}
                            onClick={() => this.onClickStart()}>
                            Start
                        </div>
                    </div>

                    <div className="pro-tips mt-3 p-3">
                        <div><img className="bulb-image-size" src={getImageSource(ImageConstants.BULB_IMAGE)} /> <span className="pro-title">Pro tips:</span></div>
                        <ul>
                            {
                                this.state.list.map((tip, index) => (
                                    <li className={`tips-text ${index >= 1 ? 'hide-list' : ''}`}>{tip.tip}</li>
                                ))
                            }
                        </ul>

                        {
                            this.state.list.length > 1 ?
                                <>
                                    {
                                        this.state.list.map((tip, index) => (
                                            <div className="cursor-pointer" onClick={() => this.showMore()}>
                                                {index === 1 ? <div id='show-more'>{`See More`}</div> : ''}
                                            </div>
                                        ))
                                    }
                                </>

                                :

                                ''
                        }
                    </div>
                </>
                {this.state.showClickerSetPopup ? this.renderClickerSetPopup() : <></>}

                {/* {this.state.showChaptersPopup && <ChapterListPopup modal={true} close={this.hideChapters} delegate={this} chapters={this.chapterTitles} categoryThemeId={this.state.categoryId} />} */}
            </div>
        )
    }
}


export default StartAssessment;